import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentFulfill() {
  return (
    <FulfillmentQueue
      title="Fulfill"
      statusFilter="fulfilling"
      emptyMessage="No orders being fulfilled"
    />
  );
}
